import {CoreDI, Installer} from '@gongxigames/framework/core';
import {SlotSettings} from '@gongxigames/framework/slot/configs/SlotSettings';

export function isEnabledLightAndWonder(components: Installer): boolean {
    return components.getComponent<SlotSettings>(CoreDI.Settings).get('integrationType') === 'lnw' || false;
}
